import React from "react";
import VariationOrderRouter from './variation-order/Router';
export { getFields } from './variation-order/Router';

export default function PMVariationOrderRouter(props) {
    return <VariationOrderRouter {...props}/>;
}